import JwtDecode from "jwt-decode";

const tokenKey = "token";

export function getCurrentUser() {
  try {
    const jwt = localStorage.getItem(tokenKey);
    return JwtDecode(jwt);
  } catch (error) {
    return null;
  }
}

export async function setAdToken(token) {
  localStorage.setItem(tokenKey, token);
  localStorage.setItem("loginType", "ad");
}

export function getJwt() {
  const token = localStorage.getItem("token");
  if (token === null) return "";
  return token;
}

export function getLoginUser() {
  return localStorage.getItem("currentUser");
}

export default {
  getCurrentUser,
  getJwt,
  getLoginUser,
  setAdToken,
};
